import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'frontend-live-show-chat',
  templateUrl: './live-show-chat.component.html',
  styleUrls: ['./live-show-chat.component.scss'],
})
export class LiveShowChatComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
